// removed by extract-text-webpack-plugin
module.exports = {"OneClick":"OneClick-module__OneClick__gd011","OneClickInnerWrapper":"OneClick-module__OneClickInnerWrapper__2rq7f","HeaderWrapper":"OneClick-module__HeaderWrapper__3AG7I","Header":"OneClick-module__Header__2stmP","Row":"OneClick-module__Row__1fWrH","SubHeader":"OneClick-module__SubHeader__1B5ar","Permissions":"OneClick-module__Permissions__1ttk1","CheckBox":"OneClick-module__CheckBox__2Bmm0","ButtonWrapper":"OneClick-module__ButtonWrapper__neMBe","Footer":"OneClick-module__Footer__2_WAM","Link":"OneClick-module__Link__3ee5M"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/OneClick/OneClick.module.css
// module id = 1756
// module chunks = 29